// extracted by mini-css-extract-plugin
module.exports = {"body":"Content_body__338bZ"};